import React from 'react';
import type { TranscodeProgress } from './videoTranscode';
import './VideoModalTranscode.css';

interface VideoTranscodeOverlayProps {
  transcodeProgress: TranscodeProgress | null;
  transcodeFailed: boolean;
}

// Shown over a <video> while useVideoDecodeFallback converts it, or when it
// cannot. The parent must be position: relative.
const VideoTranscodeOverlay: React.FC<VideoTranscodeOverlayProps> = ({
  transcodeProgress,
  transcodeFailed,
}) =>
{
  if (transcodeProgress)
  {
    return (
      <div className="video-modal__converting">
        <p>Preparing this video for your browser&hellip;</p>
        <p className="video-modal__converting-detail">
          {transcodeProgress.stage === 'transcoding'
            ? `${Math.round((transcodeProgress.ratio ?? 0) * 100)}%`
            : transcodeProgress.stage === 'queued'
              ? 'Waiting for another video to finish'
              : 'Loading converter'}
        </p>
      </div>
    );
  }

  if (transcodeFailed)
  {
    return (
      <div className="video-modal__converting">
        <p>This video&rsquo;s format isn&rsquo;t supported by your browser.</p>
        <p className="video-modal__converting-detail">
          Download the file to play it locally.
        </p>
      </div>
    );
  }

  return null;
};

export default VideoTranscodeOverlay;
